import {
  Outlet, createRootRoute, useRouterState,
} from '@tanstack/react-router';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useEffect } from 'react';
import theme from '../styles/theme';
import DatadogUserTracking from '../components/datadog-user-tracking/datadog-user-tracking';
import { StatusMessageProvider } from '../hooks/StatusMessageContext';

const RootLayout = () => {
  const routerState = useRouterState();

  // Hide the initial loading overlay when React is ready AND all loaders are complete
  useEffect(() => {
    // Check if router is not pending (all loaders complete)
    if (routerState.status !== 'pending') {
      document.body.classList.add('react-ready');
    }
  }, [ routerState.status ]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <StatusMessageProvider>
        <DatadogUserTracking />
        <Outlet />
      </StatusMessageProvider>
    </ThemeProvider>
  );
};

export const Route = createRootRoute({
  component: RootLayout,
});
